module.exports = __webpack_public_path__ + "img/y-48.6b96bbc2.png";